<div class="employee-form-wrapper">
  <!-- photo -->
  <app-photo [image]="employeeAvatar" [editable]="true" (imageReadyEvent)="setEmployeeAvatar($event)" *ngIf="!loadingAvatar"></app-photo>
  <!-- form -->
  <form [formGroup]="form" class="employee-form" *ngIf="form">
    <div>
      <!-- firstname -->
      <app-form-input-text [field]="'firstname'" [formControl]="f['firstname']" formControlName="firstname"></app-form-input-text>
      <!-- lastname -->
      <app-form-input-text [field]="'lastname'" [formControl]="f['lastname']" formControlName="lastname"></app-form-input-text>
    </div>
    <div class="admin-wrapper">
      <!-- tenant -->
      <app-form-input-text [field]="'tenant'" [formControl]="f['tenant']" formControlName="tenant"></app-form-input-text>
      <!-- username -->
      <app-form-input-text [field]="'username'" [formControl]="f['username']" formControlName="username"
        (blurEvent)="checkUsername()"></app-form-input-text>
      <!-- admin role -->
      <div class="admin">
        <label [innerHTML]="'roles.admin' | translate" class="input-label"></label>
        <p-selectbutton [options]="adminOptions" formControlName="isAdmin" optionLabel="name" optionValue="value" />
      </div>
    </div>
    <div>
      <!-- phone -->
      <app-form-input-text-group [field]="'phone'" [formControl]="f['phone']" formControlName="phone"
        [pre]="'+34'" [preIcon]="'flag-icon flag-es'" [label]="'field.phone' | translate"></app-form-input-text-group>
      <!-- email -->
      <app-form-input-text [field]="'email'" [formControl]="f['email']" formControlName="email"></app-form-input-text>
    </div>
    <div class="professional-info" *ngIf="_.get(f['roles']?.value, 'professional')">
      <!-- occupation -->
      <app-form-input-dropdown [options]="occupationTypes" [optionsField]="'name'" [noLabel]="false" [appendTo]="'body'" [clearable]="true"
        [filter]="false" [field]="'occupation'" [formControl]="f['occupation']" formControlName="occupation"></app-form-input-dropdown>
      <!-- professionalAssociation -->
      <app-form-input-text [field]="'professionalAssociation'" [formControl]="f['professionalAssociation']" formControlName="professionalAssociation"></app-form-input-text>
      <!-- professionalCode -->
      <app-form-input-text [field]="'professionalCode'" [formControl]="f['professionalCode']" formControlName="professionalCode"></app-form-input-text>
    </div>
    <div class="vacations-info" *ngIf="!employee && _.get(f['roles']?.value, 'employee')">
      <!-- daysOfVacationsThisYear -->
      <app-form-input-number [field]="'daysOfVacationsThisYear'" [formControl]="f['daysOfVacationsThisYear']" formControlName="daysOfVacationsThisYear" 
        [decimals]="0" [label]="'field.daysOfVacationsThisYear' | translate: {year: moment().year()}"></app-form-input-number>
      <!-- daysOfVacations -->
      <app-form-input-number [field]="'daysOfVacations'" [formControl]="f['daysOfVacations']" formControlName="daysOfVacations" 
        [decimals]="0" [label]="'field.daysOfVacations' | translate: {year: moment().year() + 1}"></app-form-input-number>
      <!-- typeOfVacations -->
      <app-form-input-dropdown [options]="vacationTypes" [optionsField]="'name'" [noLabel]="false" [appendTo]="'body'" [clearable]="false"
        [filter]="false" [field]="'typeOfVacations'" [formControl]="f['typeOfVacations']" formControlName="typeOfVacations"></app-form-input-dropdown>
    </div>
    <!-- roles -->
    <div class="roles-wrapper" formArrayName="roles">
      <label [htmlFor]="'roles'" [innerHTML]="'field.roles' | translate" class="input-label"></label>
      <div class="roles">
        <div *ngFor="let role of roles; let i = index" class="role">
          <p-checkbox
            [inputId]="role.id"
            [formControlName]="role.id"
            [value]="role.id"
            [binary]="true"
          ></p-checkbox>
          <label [for]="role"> {{ role.name }} </label>
        </div>
      </div>
    </div>
  </form>
  <!-- buttons -->
  <div class="buttons">
    <p-button [label]="'button.cancel' | translate" severity="secondary" (click)="cancel()"/>
    <p-button [label]="'button.save' | translate" severity="contrast" (click)="save()"/>
  </div>
</div>
    